import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { upperFirstOnly } from 'utils/format'
import { MultiSelect } from 'components/common/multi-select'

const SplitByDropdown = ({ items, value, onValueChange, onDropdownClick, dataTestId }) => {
  const { t } = useTranslation()

  return (
    <MultiSelect
      placeholder={upperFirstOnly(t('widgets.analytics.splitByPlaceholder'))}
      allItemsText={upperFirstOnly(t('widgets.analytics.allSelected'))}
      items={items}
      value={value}
      minSelected={0}
      onValueSelect={onValueChange}
      onDropdownClick={onDropdownClick}
      dataTestId={dataTestId}
    />
  )
}

SplitByDropdown.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.arrayOf(PropTypes.string),
  onValueChange: PropTypes.func,
  onDropdownClick: PropTypes.func,
  dataTestId: PropTypes.string,
}

SplitByDropdown.defaultProps = {
  items: [],
  value: [],
  onValueChange: () => {},
  onDropdownClick: () => {},
}

export { SplitByDropdown }
